import { Routes, Route } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { GlobalProtectedRoute } from 'framework/authorization';
import TeamDashboard from './dashboard/List/StaffingDashboard';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Router } from 'framework/routing';
import { VIEW_STAFFING_DASHBOARD } from './constants';
import { STAFFING_DASHBOARD_PATH } from 'domain/shared/core/sharedRouteConstants';

const StaffingDashboardRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  return (
    <ProtectedRouter basePath={STAFFING_DASHBOARD_PATH}>
      <Routes>
        <Route
          index
          element={
            <GlobalProtectedRoute globalPermissionToCheck={VIEW_STAFFING_DASHBOARD}>
              <TeamDashboard />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

StaffingDashboardRouter.getRouterPath = () => `${STAFFING_DASHBOARD_PATH}/*`;

export default StaffingDashboardRouter;
